import React from 'react';
import { Leaf, Truck, Award, Calendar } from 'lucide-react';

export default function Features() {
  const features = [
    {
      icon: <Leaf className="w-8 h-8 text-brand" />,
      title: "Eco-Friendly Options",
      description: "We use environmentally safe cleaning methods that are tough on stains but gentle on the planet."
    },
    {
      icon: <Truck className="w-8 h-8 text-brand" />,
      title: "Pickup & Delivery",
      description: "Convenient door-to-door service for busy professionals and families in Santa Rosa."
    },
    {
      icon: <Award className="w-8 h-8 text-brand" />,
      title: "Trusted Specialists",
      description: "Our experienced team treats every garment with the utmost care and attention to detail."
    },
    {
      icon: <Calendar className="w-8 h-8 text-brand" />,
      title: "Easy Scheduling",
      description: "Schedule your service by giving us a call. We’ll coordinate pickup and delivery around your schedule for maximum convenience."
    }
  ];

  return (
    <section className="py-16 bg-white relative z-10 -mt-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_4px_25px_rgba(0,0,0,0.1)] transition-shadow border border-gray-50 flex flex-col items-center text-center group"
            >
              <div className="w-16 h-16 bg-surface rounded-full flex items-center justify-center mb-6 group-hover:bg-brand/10 transition-colors">
                {feature.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
